export default __webpack_public_path__ + "static/media/home-restaurant-img-18.c3af3c52.jpg";